import { useState, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import EventSegmentationFilters from 'automation-ui-enrollment/components/eventEnrollment/steps/EventSegmentationFilters';
import { applyEventTriggersToFlow } from 'automation-ui-canvas/create/utils/applyTriggers';
import { UNKNOWN_ID } from 'automation-ui-references/object-types/CRMObjectTypes';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_FILTER_BRANCH = {
  filterBranches: [],
  filterBranchOperator: 'OR',
  filterBranchType: 'OR',
  filters: []
};
export default function EventTriggerStep({
  selectedTriggerOption,
  objectTypeId,
  flow,
  setFlow,
  setValidationMessage
}) {
  var _triggers, _flow$enrollmentCrite;
  const filterBranch = (_triggers = (_flow$enrollmentCrite = flow.enrollmentCriteria) === null || _flow$enrollmentCrite === void 0 ? void 0 : _flow$enrollmentCrite.triggers) !== null && _triggers !== void 0 ? _triggers : EMPTY_FILTER_BRANCH;
  const [areFiltersIncomplete, setAreFiltersIncomplete] = useState(
  // the filter component doesn't tell us if the initial filter value is valid, this event is the only exception
  selectedTriggerOption.fullyQualifiedName === 'e_property_value_changed');
  const handleFilterChange = newFilterBranch => {
    setFlow(draftFlow => {
      applyEventTriggersToFlow(newFilterBranch, draftFlow);
    });
  };
  const isObjectTypeSelected = objectTypeId !== UNKNOWN_ID;
  const isValid = !areFiltersIncomplete && !isFilterEmpty(filterBranch);
  useEffect(() => {
    if (!isObjectTypeSelected) {
      setValidationMessage(I18n.text('createWorkflow.selectRequiredObjectTypeTooltip'));
    } else if (!isValid) {
      setValidationMessage(I18n.text('automation-ui-enrollment.redesign.saveButton.tooltip.editingFilters'));
    } else {
      setValidationMessage(null);
    }
  }, [isValid, isObjectTypeSelected, setValidationMessage]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h5",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createWorkflow.startTriggerHeader"
      })
    }), /*#__PURE__*/_jsx(EventSegmentationFilters, {
      value: filterBranch,
      objectTypeId: objectTypeId,
      openInEditMode: true,
      readOnly: false,
      strategyOptions: {
        showListMembershipFilterFamily: true
      },
      onAreFiltersIncompleteChange: setAreFiltersIncomplete,
      onChange: handleFilterChange
    }, objectTypeId)]
  });
}
export const eventTriggerStep = {
  component: EventTriggerStep,
  getLabel: () => I18n.text('createWorkflow.step.selectTrigger')
};